// Libarary Class
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, HostListener, Inject, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Subscription } from 'rxjs';
const _ = require('lodash');

// Service Class
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { AssociateCropService } from './../../../../services/seed/associate-crop.service';


// Class
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-associate-crop-create-order',
  templateUrl: './associate-crop-create-order.component.html',
  styleUrl: './associate-crop-create-order.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AssociateCropCreateOrderComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  associateCropLeadDate = 0;
  dashboardFilter: DashboardFilter;
  deliverToData: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  associateOrder: AssociateOrder;
  associateLocationData: any;
  shipToData: any;
  isProductExist = false;
  cropTypeData: any;
  displayedColumns: string[] = ['marketingBrand', 'variety', 'availableQty', 'orderQty', 'uom', 'preferredPackagingSize'];
  selectedDealer: any;
  deliverTo: any;
  locationDetail: any;
  isNotValid: any;
  isPlaceOrderDisable = true;
  associateItemList: any;
  associateLocationList: any;
  associateOriginalLocationData: any;
  productSearchFilter: any;
  productFilters: any;
  marketingMasterList: any = [];
  filterValueList: any = [];
  shipToDataLoading = true;
  locationDataLoading = true;
  associateOrderSource: MatTableDataSource<any>;
  errorsList: Array<string> = [];
  error = false;
  associateOrderSourceCopy: any;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  index = 0;
  nextErrorId = 0;
  isEditMode = false;
  datemodel: NgbDateStruct;
  dateFilter: any;
  hasChangeAdded = false;
  userMenuAccessList: any;
  maxDate: Date = new Date();
  minDate: Date = new Date();
  readOnlyAccess = false;
  soldOutItemMsg: string = '';

  // Search Type set Up for grid
  searchTypeList: any[] = [
    { name: 'Variety', value: 'Variety' },
    { name: 'Marketing Brand', value: 'marketingBrand' }
  ];

  constructor(public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private router: Router,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private associateCropService: AssociateCropService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
    this.associateOrder = new AssociateOrder();
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  ngOnInit() {
    this.setDefaultData();
    this.getAssociateCropInitialData();
    this.bindDataSource([], true);
    this.resetProductFilter();
    this.getOrderDetails();
  }

  setDefaultData() {
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
        } else {
          this.router.navigate(['/cc/landing-data']);
        }
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        this.soldOutItemMsg = isActiveUser && isActiveUser.associateSoldOutItemMsg && isActiveUser.associateSoldOutItemMsg != 'ASSOC_CROP_SOLDOUT_ORDER_MSG' ? isActiveUser.associateSoldOutItemMsg : 'No item to Place Order.';
        if (isActiveUser.associateCropLeadDate) {
          this.associateCropLeadDate = isActiveUser.associateCropLeadDate;
          
          const currentDate = new Date();
          this.associateOrder.RequestedDate = this.addBusinessDays(currentDate, this.associateCropLeadDate);
        }
      }
    }
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
      this.maxDate = new Date(this.headerYear, 11, 31, 23, 59, 59);
    }
    this.minDate = this.minDate > this.maxDate ? this.maxDate : this.minDate;
    this.errorMsgs = new Array();
  }

   addBusinessDays(startDate: Date, leadDays: number): Date {
  let result = new Date(startDate);

  // Special case: if leadDays = 0 and today is weekend → push to next Monday
  if (leadDays === 0 && (result.getDay() === 0 || result.getDay() === 6)) {
    do {
      result.setDate(result.getDate() + 1);
    } while (result.getDay() === 0 || result.getDay() === 6);
    return result;
  }

  // Normal case: add business days
  for (let i = 0; i < leadDays;) {
    result.setDate(result.getDate() + 1);
    if (result.getDay() !== 0 && result.getDay() !== 6) {
      i++;
    }
  }

  return result;
}

  // Get Associate Crop Initial Data
  getAssociateCropInitialData() {
    this.loaderService.setLoaderStatus(true);
    const forkJoinAPIs = [];
    forkJoinAPIs.push(this.associateCropService.getSeedCropAssociateLocations());
    forkJoinAPIs.push(this.associateCropService.getSeedCropAssociateAccount());
    this.subscription.push(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
      if (result && result.length > 0 && result[0] && result[1]) {
        this.associateLocationData = this.getLocationList(result[0]);
        this.associateOriginalLocationData = this.getAllLocationList(result[0]);
        this.cropTypeData = this.getCropTypeList(result[0]);
        this.locationDataLoading = false;
        this.associateLocationList = result[0];
        this.shipToData = result[1];
        this.shipToDataLoading = false;
      } else {
        this.locationDataLoading = false;
        this.shipToDataLoading = false;
      }
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.locationDataLoading = false;
      this.shipToDataLoading = false;
    }));
  }


  getCropYearType($event) {
    this.locationDetail = $event;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { locationUpdated: true });
    this.cropTypeData = [];
    this.clearDetailGrid();
    const seen = new Set();
    if ($event && $event.locationId) {
      this.cropTypeData = this.associateLocationList
        .filter(item => item.locationId === $event.locationId && !seen.has(item.cropTypeCode) && seen.add(item.cropTypeCode))
        .map(item => ({ cropTypeCode: item.cropTypeCode, cropDesc: item.cropDesc ? item.cropDesc : 'Blank' }));
    } else {
      this.associateOrder.CropType = null;
      this.cropTypeData = this.getCropTypeList(this.associateLocationList);
      this.associateLocationData = this.getLocationList(this.associateLocationList);
    }

  }

  setLocation($event) {
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { locationUpdated: true });
    if ($event && $event.cropTypeCode) {
      this.associateLocationData = Array.from(
        new Map(
          this.associateOriginalLocationData
            .filter(item => item.cropTypeCode === $event.cropTypeCode)
            .map(item => [item.locationId, item])
        ).values()
      );
    } else {
      this.associateLocationData = this.getLocationList(this.associateLocationList);
      this.locationDetail = $event;
      this.associateOrder.AssociateLocation = null;
      this.cropTypeData = this.getCropTypeList(this.associateLocationList);
    }

  }

  // Get Unique Location List
  getLocationList(source) {
    const result = [];
    const seen = new Set();
    for (const item of source) {
      if (!seen.has(item.locationId)) {
        seen.add(item.locationId);
        const desc = [item.associateName, item.city, item.state]
          .filter(Boolean) // remove null/undefined/empty
          .join(", ");
        result.push({ locationId: item.locationId, description: desc, contact: item.contact, email: item.email, associatePhoneNumber: item.associatePhoneNumber, cropTypeCode: item.cropTypeCode  });
      }
    }

    return result;
  }

  // Get Unique Location List
  getAllLocationList(source) {
    const result = [];
    const seen = new Set();
    for (const item of source) {
      const desc = [item.associateName, item.city, item.state]
        .filter(Boolean) // remove null/undefined/empty
        .join(", ");
      result.push({ locationId: item.locationId, description: desc, contact: item.contact, email: item.email, associatePhoneNumber: item.associatePhoneNumber, cropTypeCode: item.cropTypeCode });
    }

    return result;
  }


  // Get Unique Location List
  getCropTypeList(source) {
    const result = [];
    const seen = new Set();
    for (const item of source) {
      if (!seen.has(item.cropTypeCode)) {
        seen.add(item.cropTypeCode);
        result.push({cropTypeCode: item.cropTypeCode, cropDesc: item.cropDesc ? item.cropDesc : 'Blank' });
      }
    }

    return result;
  }

  getOrderDetails() {
    this.subscription.push(this.associateCropService.seedAssociateOrderId.subscribe(headerId => {
      if (headerId && headerId != 0) {
        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.associateCropService.GetSeedCropAssociatesOrderSummaryData(headerId).subscribe((result: any) => {
          if (result) {
            this.readOnlyAccess = true;
            this.displayedColumns = ['marketingBrand', 'variety', 'orderQty', 'uom', 'preferredPackagingSize'];
            this.cropTypeData = [
              { cropTypeCode: result.cropTypeCode, cropDesc: result.cropTypeDesc }
            ];

            const desc = [result.associateName, result.associateCity, result.associateState]
              .filter(Boolean) // remove null/undefined/empty
              .join(", ");
            // Create the object
            const locationDetails = {
              contact: result.associateContactName,
              associatePhoneNumber: result.associatePhoneNumber,
              description: desc,
              email: result.associateContactEmail,
              locationId: result.locationId
            };
            this.locationDetail = locationDetails;

            // Create the object
            const accountDetails = {
              accountNumber: result.shipToAccount,
              address1: result.shipToAddress1,
              address2: result.shipToAddress2,
              city: result.shipToCity,
              state: result.shipToState,
              zipCode: result.zipCode
            };
            this.selectedDealer = accountDetails;

            if (result.deliverToAccount) {
              // Create the object
              const deliverToDetails = {
                accountNumber: result.deliverToAccount,
                address1: result.deliverToAddress1,
                city: result.deliverToCity,
                state: result.deliverToState,
                zipCode: result.deliverToZipCode
              };
              this.deliverTo = deliverToDetails;
            }

            this.deliverToData = result.deliverTo;

            this.associateOrder.AssociateLocation = result.locationId;

            this.associateOrder.AssociateOrderId = result.orderHeaderID;
            this.associateOrder.ShipToAccount = result.shipToAccount;
            this.associateOrder.DeliverTo = result.deliverToAccount;
            this.associateOrder.DeliverToAnotherLocation = result.deliverToAccount > 0 ? true : false;
            this.associateOrder.RequestedDate = result.requestDeliverDate;
            this.associateOrder.DeliveryInstructionsCodes = result.deliverInstructions;
            this.associateOrder.IsCustomerPickup = result.customerPickup;
            this.associateOrder.CropType = result.cropTypeCode;
            this.associateOrder.CustomerPO = result.customerPO;
            let rowId: Number = 0;
            this.associateItemList = result.detailsData;
            let marketingIds = [];
            const seen = new Set();
            this.associateItemList.forEach(product => {
              if (!seen.has(product.marketingBrand)) {
                seen.add(product.marketingBrand);
                marketingIds.push({ id: product.marketingBrand, value: product.marketingBrand ? product.marketingBrand : 'Blank' });
              }
              rowId = +rowId + 1;
              product.rowId = +rowId;
              product.orderQty = product.orderQty;
              product.preferredPackagingSize = product.preferredPackagingSize;
              product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
            });
            marketingIds = marketingIds.sort((a, b) => a.value.localeCompare(b.value));
            this.marketingMasterList = marketingIds;
            this.bindDataSource(this.associateItemList, true);

          }
          this.loaderService.setLoaderStatus(false);
        }, (error) => {
          this.loaderService.setLoaderStatus(false);
        }));

      }
    }));
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSeedEditPageHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setSeedEditPageHeight();
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }

  // Observe Input element change
  ngOnChanges(changes: SimpleChanges) {
    this.productSearchFilter = this.searchTypeList[0].value;
  }

  clearDetailGrid() {
    this.productSearchFilter = this.searchTypeList[0].value;
    this.marketingMasterList = [];
    this.bindDataSource([], true);
    this.clearAllFilter();
    this.revertAllChanges();
    
  }
  // Get product list based on account selected
  getProductsList() {
    if (this.associateOrder.AssociateLocation && this.associateOrder.CropType) {
      this.loaderService.setLoaderStatus(true);
      this.clearDetailGrid();
      let rowId: Number = 0;
      this.subscription.push(this.associateCropService.getSeedCropDetailsData(this.associateOrder.AssociateLocation, this.associateOrder.CropType).subscribe(result => {
        if (result && result.length > 0) {
          this.associateItemList = result;
          let marketingIds = [];
          const seen = new Set();
          this.associateItemList.forEach(product => {
            if (!seen.has(product.marketingBrand)) {
              seen.add(product.marketingBrand);
              marketingIds.push({ id: product.marketingBrand, value: product.marketingBrand ? product.marketingBrand : 'Blank' });
            }
            rowId = +rowId + 1;
            product.rowId = +rowId;
            product.orderQty = 0;
            product.preferredPackagingSize = null;
            product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
          });
          marketingIds = marketingIds.sort((a, b) => a.value.localeCompare(b.value));
          this.marketingMasterList = marketingIds;
          this.bindDataSource(this.associateItemList, true);
        } else {
          this.isPlaceOrderDisable = true;
          this.bindDataSource([], true);
          this.toastrService.warning(this.soldOutItemMsg);
        }

        this.loaderService.setLoaderStatus(false);
      }, (error => {
        LolLoggerService.error(error);
        this.loaderService.setLoaderStatus(false);
      })));

    }
    else {
      this.bindDataSource([], true);
      this.loaderService.setLoaderStatus(false);
    }
  }


  getOrderList() {
    const associateItem = this.associateOrderSource.data.map(product => ({
      orderQty: product.orderQty,
      availableQty: product.availableQty,
      marketingBrand: product.marketingBrand,
      variety: product.variety,
      uom: product.uom,
      preferredPackagingSize: product.preferredPackagingSize?.trim()
    }));
    const {
      AssociateLocation,
      CropType,
      RequestedDate,
      ShipToAccount,
      DeliverToAnotherLocation,
      DeliverTo,
      DeliveryInstructionsCodes,
      CustomerPO,
      IsCustomerPickup
    } = this.associateOrder;

    const formattedRequestedDate = RequestedDate
      ? new Date(RequestedDate.getTime() - RequestedDate.getTimezoneOffset() * 60000)
        .toISOString()
        .split('T')[0]
      : new Date();
    const header = {
      locationId: AssociateLocation,
      cropTypeCode: CropType,
      requestedDate: formattedRequestedDate,
      shipToAccount: ShipToAccount,
      deliveredToAccount: DeliverToAnotherLocation && DeliverTo ? DeliverTo : null,
      deliveryInstruction: DeliveryInstructionsCodes?.trim(),
      custPonumber: CustomerPO?.trim() || null,
      customerPickup: !!IsCustomerPickup,
      detailsData: associateItem
    };

    return header;
  }

  validateOrder() {
    return this.validateOrderHeader() && this.validateOrderItems();
  }

  enableDisablePlaceOrder() {
    if (this.associateOrderSource && this.associateOrderSource.data && this.associateOrderSource.data.length > 0 && this.associateOrderSource.data.some(x => x.orderQty > 0)) {
      this.isPlaceOrderDisable = false;
    }
    else {
      this.isPlaceOrderDisable = true;
    }
  }


  // Place Associate Order
  placeAssociateOrder() {
    if (this.validateOrder()) {
      let associateOrder = this.getOrderList();
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.associateCropService.getSeedCropPlaceRequest(associateOrder).subscribe((result: any) => {
        if (result && result.length > 0 && result[0].orderHeaderID) {
          this.toastrService.success(`Associate Order ${result[0].orderHeaderID} Successfully Saved.`);
          this.loaderService.setLoaderStatus(false);
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
            updateButtonClick: true
          });
          this.associateCropService.setconfirmationSeedAssociateOrderId(+result[0].orderHeaderID);
          this.router.navigate(['/associate-crop/associate-crop-summary']);
        } else {
          let rowId: Number = 0;
          this.errorMsgs = new Array();
          this.associateItemList = result;
          this.associateItemList.forEach(product => {
            rowId = +rowId + 1;
            product.rowId = +rowId;
            product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
            if (product.errors && product.errors.length > 0) {
              product.errors.forEach(itemError => {
                product.lineErrors.errors.push({ id: itemError.id, error: itemError.error });
                if (product.lineErrors.errors.length > 0) {
                  this.errorMsgs = this.errorMsgs.filter(x => x.rowId != product.rowId);
                  this.errorMsgs.push(product.lineErrors);
                  this.getCommonErrors(this.errorMsgs);
                }
              });
            }
          });
          this.bindDataSource(this.associateItemList, true);
        }
        this.loaderService.setLoaderStatus(false);
      }, error => {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Order not saved in the system.');
      }));
    }
  }

  getShipTo($event) {
    this.selectedDealer = $event;
    this.deliverToData = [];
    this.associateOrder.DeliverTo = null;
    this.deliverTo = null;
    this.associateOrder.DeliverToAnotherLocation = false;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { shiptoupdated: true });
    if ($event && $event.accountNumber) {
      this.getDeliverToAccounts($event);
    }
  }

  getDeliverToAccounts($event) {
    if ($event) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliverToUpdated: true });
    }
    if ($event && $event.accountNumber && $event.parentNumber) {
      this.getDeliverToAccountsListBasedOnShipto($event.accountNumber, $event.parentNumber);
    }
  }

  getDeliverToAccountsListBasedOnShipto(accountNumber, parentAccountNumber) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.associateCropService.getSeedCropAssociateDeliverTo(accountNumber, parentAccountNumber).subscribe(result => {
      if (result && result.length > 0) {
        this.deliverToData = result;
      }
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  removeDeliverTo() {
    this.associateOrder.DeliverTo = null;
    this.deliverTo = null;
  }
  // Deliver to change event add the object to show the deliver to address
  getDeliverToAccount($event) {
    this.deliverTo = $event;
    if ($event) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { deliverToUpdated: true });
    }
  }


  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  getFilterData() {
    this.keepFilter();
    this.applyFilterData(this.productFilters);
  }

  // Keep the selected filter in case of edit
  keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.Variety && this.productFilters.Variety != '') {
          this.filterValueList.push('Variety : ' + this.productFilters.Variety);
        }
        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          let strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + (x ? x : 'Blank') + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        }
      }
    }

  }

  // Clear the selected filters
  clearAllFilter() {
    this.filterValueList = new Array();
    this.resetProductFilter();
    this.applyFilterData(this.productFilters);
  }

  // Clear single filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.applyFilterData(this.productFilters);
      if (this.filterValueList.length < 1) {
        // remove all filter
      }
    }
  }



  // To remove clear search filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Marketing Brand':
        this.productFilters.MarketingBrandList = [];
        break;
      case 'Product Name':
        this.productFilters.Variety = '';
        break;
      default:
        break;
    }
  }

  // Reset the filters
  resetProductFilter() {
    this.filterValueList = [];
    this.productFilters = {
      'Variety': null,
      'MarketingBrandList': []
    };
  }

  // Search based on filter type
  filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.value.toLocaleLowerCase().indexOf(term) > -1;
  }


  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.associateOrderSource.filter = filterValue;
  }

  quantityTextChange(productItem) {
    if (/^0/.test(productItem.orderQty) && productItem.orderQty != '0') {
      productItem.orderQty = productItem.orderQty.replace(/^0/, '');
    }
  }

  // Associate Order Unit Change and validation
  AssociateOrderUnitChange(action: string, productItem: any) {
    if (action === 'decrease') {
      productItem.orderQty = Math.max(0, +productItem.orderQty - 1);
    }
    else if (action === 'increase') {
      productItem.orderQty =  +productItem.orderQty + 1;
    }
    productItem.orderQty = Math.min(productItem.orderQty, productItem.availableQty);
    this.validateLineItem(productItem, 'orderQty');
  }


  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.associateOrderSource = new MatTableDataSource(orderList);

      this.associateOrderSource.filterPredicate = (data: any, filter: any) => {
        if (data.variety == null || data.variety == 'undefined') {
          data.variety = '';
        }
        if ((filter.Variety == null || data.variety.toLowerCase().indexOf(filter.Variety.toLowerCase()) > -1) &&
          (filter.MarketingBrandList.length == 0 || filter.MarketingBrandList.indexOf(data.marketingBrand) > -1)) {
          return true;
        }
        else {
          return false;
        }
      };

      this.applyFilterData(this.productFilters);
      // created deep copy
      if (isClone) {
        this.associateOrderSourceCopy = JSON.parse(JSON.stringify(orderList));
      }
      this.enableDisablePlaceOrder();
    }
  }

  // Validate date
  validateDate($event) {
    const currentDate = new Date();
    if ($event.value < currentDate) {
      this.associateOrder.RequestedDate = currentDate;
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { requestedDateUpdated: true });
      this.validateUserinput(true);
    }
  }


  // Validate input
  validateInput(data: any, message: string) {
    if ((typeof (data) === 'undefined' || data === null || (data == ''))) {
      if (!(this.errorsList.indexOf(message) > -1)) {
        this.errorsList.push(message);
      }
      return true;
    } else {
      return false;
    }
  }

  // Validate the validations
  validateUserinput(checkRequestedDate: boolean) {
    this.error = false;
    this.errorsList = [];
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);
    const reqDate = new Date(this.associateOrder.RequestedDate);
    if (checkRequestedDate) {
      if (reqDate < todayDate) {
        if (!(this.errorsList.indexOf('Requested date should be greater than or equal to today') > -1)) {
          this.errorsList.push('Requested date should be greater than or equal to today');
        }
      }
    } else {
      this.validateInput(this.associateOrder.AssociateLocation, 'Please select Associate Location');
      this.validateInput(this.associateOrder.ShipToAccount, 'Please select Ship To');
      this.validateInput(this.associateOrder.RequestedDate, 'Please select Requested Date');
      this.validateInput(this.associateOrder.CropType, 'Please select Crop Type');
    }

    if (this.errorsList.length !== 0) {
      this.error = true;
      $('.seedEfulfillmentOuter').scrollTop(0);
    }
  }


  // Line item validation
  validateLineItem(item: any, validateField) {
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productQuantityUpdated: true });
    this.enableDisablePlaceOrder();
    if (validateField != '') {
      if (validateField == 'orderQty') {
        if (item.availableQty < item.orderQty) {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
          item.lineErrors.errors.push({
            id: 'availableUnits', error: 'Order Qty should not be greater than Available Qty'
          });
        }
        else {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }
      }
    }

    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }
    return item;
  }


  validateOrderItems() {
    let isValidated = true;
    if (this.associateOrderSource.data && this.associateOrderSource.data.length > 0) {
      isValidated = true;
      this.associateOrderSource.data.forEach(x => {
        x = this.validateLineItem(x, 'orderQty');
        if (x.lineErrors.errors.length > 0) {
          isValidated = false;
        }
      });
    } else {
      isValidated = false;
    }
    return isValidated;
  }

  validateOrderHeader() {
    this.validateUserinput(false);
    if (this.error && this.errorsList.length > 0) {
      return false;
    }
    return true;
  }
  // Hide/show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.associateOrderSourceCopy.length > 0 && this.associateOrderSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.associateOrderSourceCopy.filter(x => x.rowId == element.rowId)[0];

        // get current object index
        const currentLineIndex = this.associateOrderSource.data.findIndex(x => x.rowId == element.rowId);
        // replace current with old object if exist
        if (currentLineIndex != -1) {
          if (this.associateOrderSource.data[currentLineIndex].availableQty <= 0) {
            this.associateOrderSource.data.splice(currentLineIndex, 1);
          }
          else {
            if (oldLineValue) {
              oldLineValue.preferredPackagingSize = this.associateOrderSource.data[currentLineIndex].preferredPackagingSize;
              if (this.associateOrderSource.data[currentLineIndex].availableQty < this.associateOrderSource.data[currentLineIndex].orderQty) {
                oldLineValue.orderQty = this.associateOrderSource.data[currentLineIndex].availableQty;
              }
              if (oldLineValue.lineErrors.errors.length > 0) {
                oldLineValue.lineErrors.errors = [];
              }
            }
            this.associateOrderSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          }
          this.bindDataSource(this.associateOrderSource.data, true);

          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != oldLineValue.rowId);

          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.rowId);
        }

        this.index = 0;
        this.currentErrorRow = 1;
      }
      else {
        // To hide all errors after revert all changes
        this.associateOrderSource.data.forEach(x => {
          if (x.lineErrors.errors.length != 0) {
            const index = this.associateOrderSource.data.findIndex(y => y.rowId == x.rowId);;
            if (x.availableQty <= 0) {
              //this.associateOrderSource.data.splice(index, 1);
              this.associateOrderSource.data = this.associateOrderSource.data.filter(
                x => !(x.lineErrors.errors.length !== 0 && x.availableQty <= 0)
              );

            } else {
              const oldLineValue = this.associateOrderSourceCopy.filter(y => y.rowId == x.rowId)[0];
              if (oldLineValue) {
                oldLineValue.preferredPackagingSize = x.preferredPackagingSize;
                if (x.availableQty < x.orderQty) {
                  oldLineValue.orderQty = x.availableQty;
                }
                if (oldLineValue.lineErrors.errors.length > 0) {
                  oldLineValue.lineErrors.errors = [];
                }
              }
              this.associateOrderSource.data[index] = JSON.parse(JSON.stringify(oldLineValue));
            }
            this.showHideLineError(index);
          }
        });

        this.bindDataSource(this.associateOrderSource.data, true);
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#orderView').scrollTop = 0;
      const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
      $('#orderView').animate({ scrollTop: nextOffset }, 1000);
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#orderView').scrollTop = 0;
      $('#orderView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // Revert all changes
  revertAllChanges() {
    this.index = 0;
    this.currentErrorRow = 1;
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
  }
  // Go to landing seed fulfillment page
  navigateToAssociateLanding() {
    this.router.navigate(['/associate-crop-landing']);
  }




  ngOnDestroy() {
    this.associateCropService.setseedAssociateOrderId(0);
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
// Class model for Release
export class AssociateOrder {
  AssociateLocation: number;
  AssociateOrderId: number;
  ShipToAccount: number;
  DeliverTo: number;
  DeliverToAnotherLocation: boolean;
  RequestedDate: Date;
  IsCustomerPickup: boolean;
  DeliveryInstructionsCodes: string;
  CustomerPO: string;
  CropType: string;
  CompanyCode: string;
  AssociateOrderItemsList: Array<AssociateOrderItems> = [];
}


export class AssociateOrderItems {
  AssociateOrderId: number;
  AssociateItemId: number;
  MarketingBrand: string;
  Variety: string;
  AvailableQty: number;
  OrderQty: number;
  UOM: string;
  preferredPackagingSize: string;
}

